// extracted by mini-css-extract-plugin
export default {"flex_dots":"DotsComp_flex_dots__Ol0D1","dots":"DotsComp_dots__Cch50"};